import { useCallback, useContext, useEffect, useMemo } from 'react';
import type { BrandInsightsPageContext } from '@trinity/chat';
import { ChatContextType } from '@trinity/chat';
import { useLoadChatInstance } from '@trinity/chat-components/components/Chat.History/hooks/index.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier.js';
import {
  MessageGenerationCreateSessionContext,
  MessageGenerationStateContext,
} from '@/screens/MessageGenSession/Context';
import { useMessageGenChatReady } from '@/screens/MessageGenSession/useMessageGenChatReady';
import { useAgentChatContextItem } from '../hooks/useAgentChatContextItem';
import { useSegmentationSessionId } from '../hooks/useSegmentationSessionId';
import { ChatContextProviders } from './ChatContextProviders';
import { ChatInterfaceNative } from './ChatInterfaceNative';

const MESSAGE_GENERATION_AGENT_IDENTIFIER = 'message-generation-agent';

/**
 * Container that resolves the message-generation-agent chat context, injects
 * `messageGenSessionId` metadata, and renders `ChatInterfaceNative`
 * wrapped in `ChatContextProviders`.
 */
export function MessageGenChatInterface({
  onClose,
  segmentIdentifier,
  segmentationRunId,
}: {
  onClose?: () => void;
  segmentIdentifier?: string | null;
  segmentationRunId?: number | null;
}): React.JSX.Element | null {
  // const agentItem = useAgentChatContextItem(MESSAGE_GENERATION_AGENT_IDENTIFIER);
  // const sessionId = useSegmentationSessionId(segmentationRunId ?? null);
  // const messageGenSession = useContext(MessageGenerationStateContext);

  // const contextData = useMemo<BrandInsightsPageContext.Agent | null>(() => {
  //   if (!agentItem) return null;
  //   return {
  //     type: ChatContextType.Agent,
  //     data: agentItem,
  //     metadata: {
  //       ...(sessionId ? { sessionId } : {}),
  //       ...(segmentIdentifier ? { segmentIdentifier } : {}),
  //       ...(messageGenSession?.id ? { messageGenSessionId: messageGenSession.id } : {}),
  //     },
  //   };
  // }, [agentItem, sessionId, segmentIdentifier, messageGenSession?.id]);

  // if (!contextData) return null;

  return (
    <ChatContextProviders>
      <MessageGenChatInterfaceInner onClose={onClose} />
    </ChatContextProviders>
  );
}

function MessageGenChatInterfaceInner({ onClose }: { onClose?: () => void }): React.JSX.Element {
  const messageGenSession = useContext(MessageGenerationStateContext);
  const createSession = useContext(MessageGenerationCreateSessionContext);
  const brandIdentifier = useActiveBrandIdentifier();
  const loadChatInstance = useLoadChatInstance();

  const messageGenChatIdentifier = messageGenSession?.chatInstanceIdentifier;

  useEffect(() => {
    if (!messageGenChatIdentifier) return;
    loadChatInstance(messageGenChatIdentifier);
  }, [loadChatInstance, messageGenChatIdentifier]);

  const isReady = useMessageGenChatReady();

  const onNewChat = useCallback(() => {
    if (!createSession || !brandIdentifier) return;
    createSession({
      brandIdentifier,
      sessionId: messageGenSession?.sessionId ?? undefined,
      initialState: {
        segmentIds: messageGenSession?.state.initialSegmentIds,
      },
    });
  }, [createSession, brandIdentifier, messageGenSession?.sessionId, messageGenSession?.state.initialSegmentIds]);

  return (
    <ChatInterfaceNative
      isReady={isReady}
      onClose={onClose}
      onNewChat={createSession && brandIdentifier ? onNewChat : null}
    />
  );
}
